import {Component, OnInit, ViewChild} from '@angular/core';
import {MatButton} from '@angular/material/button';
import {MatProgressBar} from '@angular/material/progress-bar';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {UserService} from '../../../shared/services/user.service';
import {ActivatedRoute, Router} from '@angular/router';
import {UserDetailsService} from '../../../shared/services/user-details.service';
import {UrlService} from '../../../shared/services/url.service';
import {Domain} from '../../../shared/models/company.model';
import {TranslateService} from '@ngx-translate/core';
import {StorageService} from '../../../shared/services/storage.service';
import {UpdateCurrentUser} from '../../../store/actions/current-user.actions';
import {Store} from '@ngxs/store';
import {Observable} from 'rxjs';
import {CurrentUser} from '../../../shared/models/current-user.model';
import {DirectoryService} from '../../directory/directory.service';
import {PopupWindowsService} from '../../../shared/services/popup-windows.service';

@Component({
    selector: 'app-signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css']
})
export class SigninComponent implements OnInit {
    @ViewChild(MatProgressBar) progressBar: MatProgressBar;
    @ViewChild(MatButton) submitButton: MatButton;
    public availableLangs = this.storageService.LANGUAGES;

    currentLang = this.translate.currentLang;

    signinForm: FormGroup = this.fb.group({
        email: ['', Validators.required],
        password: ['', Validators.required],
        rememberMe: [false]
    });
    public passwordErrMsg: string;
    public google = 'Google';
    public microsoft = 'Microsoft';
    public microsoftSAML = 'SAML';
    public apiPaths = new Map([
      [this.google, '/api/google-auth/signin'],
      [this.microsoft, '/api/azure-auth/signin']
    ]);
    public oauth_buttons: Array<any>;
    public saml_buttons: Array<any>;
    public gSuiteTypeName = this.directoryService.gSuiteTypeName;
    public azureADTypeName = this.directoryService.azureADTypeName;
    public scimTypeName = this.directoryService.scimTypeName;
    currentUser$: Observable<CurrentUser>;

    constructor(
        public translate: TranslateService,
        private userService: UserService,
        private router: Router,
        private userDetailsService: UserDetailsService,
        private fb: FormBuilder,
        private urlService: UrlService,
        private storageService: StorageService,
        private route: ActivatedRoute,
        private store: Store,
        private directoryService: DirectoryService,
        private popupWindowsService: PopupWindowsService
    ) {
        this.currentUser$ = this.store.select(state => state.currentUser.currentUser);
    }

    ngOnInit() {
        // Storing correct language during company signin -> user signin transition
        const langFromParams = this.route.snapshot.queryParams.lang;
        const isLangValid = this.storageService.getLangCodes().includes(langFromParams);
        if (isLangValid && langFromParams !== this.translate.currentLang) {
            this.translate.use(langFromParams);
        }

        this.userDetailsService.getMessages().subscribe(
            (res: Array<any>) => {
                if (res[0]?.tags === 'error') {
                  this.popupWindowsService.openErrorDialogWindow({message: res[0].message});
                }
            }
        );
        this.directoryService.getAuthButtons().subscribe(
            (res: Array<any>) => {
                this.oauth_buttons = res.filter(
                    button => [this.azureADTypeName, this.gSuiteTypeName].includes(button.type)
                ).map(button => button.type);
                this.saml_buttons = res.filter(button => button.type === this.scimTypeName);
            }
        );
    }

    signin() {
        const signinData = this.signinForm.value;

        this.submitButton.disabled = true;
        this.progressBar.mode = 'indeterminate';

        this.userService.login(signinData.email, signinData.password, signinData.rememberMe).subscribe(
            res => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';

                this.router.navigateByUrl('/dashboard/default');
            },
            err => {
                this.submitButton.disabled = false;
                this.progressBar.mode = 'determinate';
                if (err.status === 401) {
                    this.passwordErrMsg = err.error.detail;
                    this.signinForm.markAsPristine();
                } else {
                  this.popupWindowsService.openErrorDialogWindow({message: err.error.detail});
                }
            }
        );
    }

    samlLogin(dirID) {
        window.location.href = '/api/saml/' + dirID + '/login';
    }

    OAuth(provider) {
        window.location.href = this.apiPaths.get(provider);
    }
}
